import { Controller } from "@hotwired/stimulus"
import pageMessageBroker from "../page_message_broker"

export default class extends Controller {
  static targets = ["editButton", "editForm", "field", "noteInput"]
  static values = { 
    updateUrl: String,
    path: String,
    initialValue: String
  }

  connect() {
    this.renderMode = "menu"
    this.originalValue = this.initialValueValue
  }

  showEditForm() {
    this.renderMode = "editing"
    this.editButtonTarget.style.display = "none"
    this.editFormTarget.style.display = "block"
    
    // Focus the field input
    const input = this.fieldTarget.querySelector("input, select, textarea")
    if (input) {
      input.focus()
    }
  }

  cancel() {
    this.renderMode = "menu"
    this.editButtonTarget.style.display = "block"
    this.editFormTarget.style.display = "none"
    
    // Reset field value
    const input = this.fieldTarget.querySelector("input, select, textarea")
    if (input) {
      input.value = this.originalValue
    }
    
    // Reset note
    if (this.hasNoteInputTarget) {
      this.noteInputTarget.value = ""
    }
  }

  save(event) {
    event.preventDefault()
    
    const input = this.fieldTarget.querySelector("input, select, textarea")
    const newValue = input ? input.value : ""
    const note = this.hasNoteInputTarget ? this.noteInputTarget.value : ""
    
    // Disable form during save
    this.setFormState(false)
    
    const data = {
      path: this.pathValue,
      value: newValue,
      note: note
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    
    fetch(this.updateUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      credentials: 'include',
      body: JSON.stringify(data),
    })
    .then(response => {
      if (response.ok) {
        // Update original value
        this.originalValue = newValue
        
        // Hide edit form
        this.renderMode = "menu"
        this.editButtonTarget.style.display = "block"
        this.editFormTarget.style.display = "none"
        
        // Clear note
        if (this.hasNoteInputTarget) {
          this.noteInputTarget.value = ""
        }
        
        // Notify that field was saved
        pageMessageBroker.dispatch("fieldValueSaved", {})
      } else {
        console.error('Failed to update attribute')
        alert('Failed to update attribute')
      }
    })
    .catch(error => {
      console.error('Error updating attribute:', error)
      alert('Error updating attribute')
    })
    .finally(() => {
      this.setFormState(true)
    })
  }

  setFormState(enabled) {
    const form = this.editFormTarget
    const inputs = form.querySelectorAll("input, select, textarea, button")
    
    inputs.forEach(input => {
      input.disabled = !enabled
    })
  }
}